import AIMS_FLAVORS from 'lib/aimsFlavors';

export const cloudinaryFlavorLd = AIMS_FLAVORS.FIT_1500w;
